import React from "react";
import { CheckCircle, Building2, PhoneCall } from "lucide-react";
import { useNavigate } from "react-router-dom";

const features = [
    "Underground stacked design for maximum space efficiency",
    "No need for ramps or driveways",
    "Independent vehicle access with mechanical lifts",
    "Protects vehicles from weather and theft",
    "Ideal for high-density urban areas with space constraints",
];

const applications = [
    "Basements of Residential Buildings",
    "Commercial Towers in Urban Areas",
    "Hospitals and High-End Clinics",
    "Star Hotels and Business Parks",
    "Government and Institutional Facilities",
];

const PuzzlePitParkingDetail = () => {
    const navigate = useNavigate()
    return (
        <section className="about-wrapper">
            {/* Hero */}
            <div className="about-hero">
                <div className="hero-content">
                    <h1>Puzzle Pit Parking System</h1>
                    <p>
                        A space-saving underground parking solution with vertical lifting and horizontal shifting platforms — engineered for smart, safe, and efficient car stacking.
                    </p>
                </div>
            </div>

            {/* Description */}
            <div className="about-section">
                <h2>What is Puzzle Pit Parking?</h2>
                <p>
                    Puzzle Pit Parking is a semi-automatic system that utilizes underground pits to stack multiple levels of vehicles in a vertical grid. Cars can be moved horizontally and vertically using intelligent controls to access a specific platform without disturbing others.
                </p>
                <p>
                    This solution is perfect for buildings that need to maximize parking capacity within limited ground area. Puzzle pit systems can go 2 to 4 levels deep and are customizable based on site requirements.
                </p>
            </div>

            {/* Features */}
            <div className="about-section">
                <h2>Key Features & Benefits</h2>
                <ul className="lt-puzzle-list">
                    {features.map((item, index) => (
                        <li key={index}><CheckCircle size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* How it Works */}
            <div className="about-section">
                <h2>How It Works</h2>
                <p>
                    Vehicles are driven onto a platform at the entry level. The system uses a combination of lifts and sliders to position the car into a vacant underground slot. To retrieve a vehicle, the platform rises and shifts horizontally to the access point.
                </p>
                <p>
                    Safety is ensured through mechanical locks, sensors, and a PLC-based control system. Operation is user-friendly and can be managed via touchscreen or RFID-based systems.
                </p>
            </div>

            {/* Applications */}
            <div className="about-section">
                <h2>Best Suited For</h2>
                <ul className="lt-puzzle-list">
                    {applications.map((item, index) => (
                        <li key={index}><Building2 size={18} /> {item}</li>
                    ))}
                </ul>
            </div>

            {/* Call to Action */}
            <div className="lt-puzzle-cta">
                <div className="lt-puzzle-cta-content">
                    <h3>Need Puzzle Pit Parking for your building?</h3>
                    <p>Contact LIFTECH ENGINEERING PVT. LTD. today for customized design and cost-effective underground solutions.</p>
                    <button className="lt-puzzle-contact-btn" onClick={() => navigate("/get-started")}>
                        <PhoneCall size={18} /> Request Consultation
                    </button>
                </div>
            </div>
        </section>
    );
};

export default PuzzlePitParkingDetail;
